// 编辑区域 undo redo 管理

import FJUtil from '../util/FJUtil';

const MAX_HISTORY = 30;

class FJUndoRedoManager {
    undoStack = [];
    redoStack = [];

    constructor() {}

    undo() {
        const state = this.undoStack.pop();
        return state;
    }

    redo() {
        const state = this.redoStack.pop();
        return state;
    }

    async addUndo(state, isRedo = false) {
        const len = this.undoStack.length;

        if (len >= MAX_HISTORY) {
            this.undoStack.shift();
        }

        this.undoStack.push(state);
        !isRedo && (this.redoStack = []);
    }

    async addRedo(state) {
        const len = this.redoStack.length;

        if (len >= MAX_HISTORY) {
            this.redoStack.shift();
        }

        this.redoStack.push(state);
    }

    hasUndo() {
        return this.undoStack.length > 0;
    }

    hasRedo() {
        return this.redoStack.length > 0;
    }

    clear() {
        this.undoStack = [];
        this.redoStack = [];
    }

    getUndoAndRedoData() {
        return {
            undoStack: FJUtil.deepClone(this.undoStack),
            redoStack: FJUtil.deepClone(this.redoStack),
        };
    }

    setUndoAndRedoData(undoAndRedoData) {
        this.undoStack = FJUtil.deepClone(undoAndRedoData.undoStack);
        this.redoStack = FJUtil.deepClone(undoAndRedoData.redoStack);
    }
}

export default FJUndoRedoManager;
